module.exports = __webpack_public_path__ + "static/forecast/fresh-snow/waist-bddc02b4f3e55b0f8331fd036e579af5.svg";